export default __webpack_public_path__ + "static/media/error.2da5856e.svg";